var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import * as actions from '../actions/index';
export var initialState = {
    loading: false,
    error: '',
    sent: false,
    entities: {},
    ids: []
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    switch (action.type) {
        case actions.REQUEST_INVITATION_SEND:
            return __assign({}, state, { loading: true, error: '' });
        case actions.RESPONSE_FAIL_INVITATION_SEND:
            return __assign({}, state, { loading: false, error: JSON.stringify(action.payload) });
        case actions.RESPONSE_SUCCESS_INVITATION_SEND:
            return __assign({}, state, { loading: false, error: '', sent: true });
        case actions.REQUEST_INVITATION_RESET:
            return __assign({}, state, { error: '', sent: false });
        case actions.REQUEST_INVITATION_UPLOAD:
            return __assign({}, state, { error: '', loading: true });
        case actions.RESPONSE_SUCCESS_INVITATION_UPLOAD:
            return __assign({}, state, { error: '', loading: false, sent: true });
        case actions.RESPONSE_FAIL_INVITATION_UPLOAD:
            return __assign({}, state, { loading: false, sent: false, error: JSON.stringify(action.payload) });
        case actions.REQUEST_INVITATIONS_PENDING:
            return __assign({}, state, { loading: true, error: '' });
        case actions.RESPONSE_SUCCESS_INVITATIONS_PENDING:
            var ids = action.payload.map(function (org) { return org.id; });
            var entities = action.payload.reduce(function (acc, entity) {
                var _a;
                return (__assign({}, acc, (_a = {}, _a[entity.id] = entity, _a)));
            }, {});
            return __assign({}, state, { loading: false, ids: ids, entities: entities });
        case actions.RESPONSE_FAIL_INVITATIONS_PENDING:
            return __assign({}, state, { loading: false, sent: false, error: JSON.stringify(action.payload) });
        case actions.RESPONSE_SUCCESS_INVITATION_RESEND:
            return __assign({}, state, { ids: Array.from(new Set(state.ids.concat([action.payload.id]))), entities: __assign({}, state.entities, (_a = {}, _a[action.payload.id] = action.payload, _a)) });
        case actions.RESPONSE_SUCCESS_INVITATION_CANCEL:
            var newEntities = __assign({}, state.entities);
            delete newEntities[action.payload.id];
            var newIds = state.ids.filter(function (id) { return id !== action.payload.id; });
            return __assign({}, state, { loading: false, entities: newEntities, ids: newIds });
        default:
            return state;
    }
}
export var createSelectors = function (rootReducer) { return ({
    getError: createSelector(rootReducer, function (state) { return state.error; }),
    getLoading: createSelector(rootReducer, function (state) { return state.loading; }),
    getSent: createSelector(rootReducer, function (state) { return state.sent; }),
    getPending: createSelector(rootReducer, function (state) { return state.ids.map(function (id) { return state.entities[id]; }); })
}); };
